import React, { useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'
import { StyledButton, StyledHeader } from './styles'
import Question from './Question'

export default function Play() {
  const [loading, setLoading] = useState(true)
  const [questions, setQuestions] = useState([])
  const [excludedQuestions, setExcludedQuestions] = useState([])
  const [currentQuestionIdx, setCurrentQuestionIdx] = useState(0)
  const [score, setScore] = useState(0)
  const [finished, setFinished] = useState(false)

  const loadQuestions = useCallback(() => {
    fetch('/.netlify/functions/questions', {
      method: 'POST',
      body: JSON.stringify(excludedQuestions),
    })
      .then((r) => r.json())
      .then((r) => {
        setLoading(false)
        setQuestions(r)
      })
  }, [excludedQuestions])

  useEffect(() => {
    loadQuestions()
  }, [loadQuestions])

  const handleOnNext = (success) => {
    if (success) setScore((s) => s + 1)

    const nextIdx = currentQuestionIdx + 1
    if (nextIdx >= questions.length) {
      setFinished(true)
    } else {
      setCurrentQuestionIdx(nextIdx)
    }
  }

  const handlePlayAgain = () => {
    setScore(0)
    setFinished(false)
    setCurrentQuestionIdx(0)
    setLoading(true)
    setExcludedQuestions((ex) => [...ex, ...questions.map((s) => s.show.id)])
  }

  if (loading) return <StyledHeader>Loading..</StyledHeader>

  if (!loading && questions.length === 0)
    return <StyledHeader>Out of questions! :(</StyledHeader>

  const question = questions[currentQuestionIdx]
  if (!question) return null

  return (
    <>
      <StyledHeader>
        {finished ? 'You scored' : 'Which show is this?'}
      </StyledHeader>
      {finished ? (
        <Scoring>
          <StyledHeader as="span">
            {score + '/' + questions.length}
          </StyledHeader>
          <StyledButton onClick={handlePlayAgain}>Play again?</StyledButton>
        </Scoring>
      ) : (
        <Question question={question} onNext={handleOnNext} />
      )}
    </>
  )
}

const Scoring = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;

  span {
    text-align: center;
    font-size: 120px;
  }
`
